import type { SavedDesign } from "../data/model";

export const STORAGE_KEY = "reunang-demo-v1";

export const readSavedDesign = (): SavedDesign | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<SavedDesign>;
    if (parsed.version !== 1 || !parsed.profile || !Array.isArray(parsed.design) || !parsed.packageId) {
      return null;
    }
    return parsed as SavedDesign;
  } catch {
    return null;
  }
};

export const writeSavedDesign = (value: SavedDesign) =>
  localStorage.setItem(STORAGE_KEY, JSON.stringify(value));

export const clearSavedDesign = () => localStorage.removeItem(STORAGE_KEY);
